import {
  normalizeNonNegativeDecimalNumber,
  parseNonNegativeDecimalInput,
} from "utils/input.normalize.logic";
import { canDeleteHistoryItemForEmploymentStartDate } from "../profilePanel.history.logic";

export interface SalaryHistoryItem {
  readonly id: number;
  readonly startDate: string;
  readonly value: number | null;
}

const salaryFormatter = new Intl.NumberFormat("sv-SE", {
  minimumFractionDigits: 2,
  maximumFractionDigits: 2,
});

interface FindSalaryHistoryItemByIdParams {
  readonly salaryHistory: readonly SalaryHistoryItem[];
  readonly salaryId: number;
}

interface IsEmploymentStartSalaryRowParams {
  readonly employmentStartDateIso: string | null;
  readonly salaryStartDate: string;
}

export function findSalaryHistoryItemById(
  params: FindSalaryHistoryItemByIdParams,
): SalaryHistoryItem | null {
  return (
    params.salaryHistory.find(
      (salaryItem) => salaryItem.id === params.salaryId,
    ) ?? null
  );
}

export function isEmploymentStartSalaryRow(
  params: IsEmploymentStartSalaryRowParams,
): boolean {
  return !canDeleteHistoryItemForEmploymentStartDate(
    params.salaryStartDate,
    params.employmentStartDateIso,
  );
}

export function toEditingSalaryValue(value: number | null): string {
  return normalizeNonNegativeDecimalNumber(value);
}

export function toHistorySalary(value: number | null): string {
  if (value == null || !Number.isFinite(value)) return "-";
  return salaryFormatter.format(value);
}

export function toParsedEditedSalaryValue(value: string): number {
  return parseNonNegativeDecimalInput(value);
}
